import React from "react";
import {TextField} from "@mui/material";
import {forms, objects, strings} from "@atttomyx/shared-utils";

const TaskForm = (props) => {
    const { data, onChange : onSync } = props;

    const onChange = (field, value) => {
        const modified = objects.deepCopy(data);

        modified[field] = value;
        modified.valid = strings.isNotBlank(modified.title) && strings.isNotBlank(modified.date);

        onSync(modified);
    }

    return <div className="task-form">
        <div className="field">
            <TextField
                required={true}
                label="Title"
                type="text"
                value={forms.sanitizeValue(data.title)}
                onChange={(event) => onChange("title", event.target.value)}
            />
        </div>
        <div className="field">
            <TextField
                label="Description"
                type="text"
                multiline={true}
                minRows={2}
                value={forms.sanitizeValue(data.description)}
                onChange={(event) => onChange("description", event.target.value)}
            />
        </div>
        <div className="field">
            <TextField
                required={true}
                label="Date"
                type="date"
                value={forms.sanitizeValue(data.date)}
                onChange={(event) => onChange("date", event.target.value)}
            />
        </div>
        <div className="field">
            <TextField
                label="Time"
                type="time"
                value={forms.sanitizeValue(data.time)}
                onChange={(event) => onChange("time", event.target.value)}
            />
        </div>
    </div>
}

export default TaskForm;
